import ConfigNovaSlaCalendarizacaoSchema from '@/schema/ConfigNovaSlaCalendarizacao.schema'
import ConfigNovaSla from '@/model/resource/ConfigNovaSla'

export default class ConfigNovaSlaCalendarizacao extends ConfigNovaSla {
  get $schema() {
    return ConfigNovaSlaCalendarizacaoSchema(this)
  }
}
